export const Config = {
  title: "Food Network Kitchen Inspirations",
  social: [
    {
      network: "pinterest",
      networkURL: "https://www.pinterest.com",
      icon: "/img/social/pinterest.svg",
      baseURL:
        "http://www.pinterest.com/pin/create/button/?url={{ shareURL }}&media={{ image }}&description={{ description }}"
    },
    {
      network: "facebook",
      networkURL: "https://www.facebook.com",
      icon: "/img/social/fb.svg",
      appId: "413220789104365"
    },
    {
      network: "twitter",
      networkURL: "https://www.twitter.com",
      icon: "/img/social/twitter.svg",
      baseURL:
        "https://twitter.com/intent/tweet?original_referer=http%3A//Food%20Network%20Kitchen%20Inspirations&amp;text={{ description }}&amp;url={{ shareURL }}"
    }
  ],
  socialWindow: {
    width: 600,
    height: 350
  },
  colors: {
    dressings: "yellow",
    sauces: "purple",
    mealKits: "green"
  }
};



// WEBPACK FOOTER //
// ./src/json/config.js